<template>
  <div>
    <h1 class="title mqu-subtitle">
      Property Details
    </h1>
    <h2 class="subtitle">
      You can enter the village name and unit number as an identifier for future reference (optional).
    </h2>
    <village-name v-model="data.villageName" v-on:input="update"/>
    <unit-number v-model="data.unitNumber" v-on:input="update"/>
  </div>
</template>

<script>
import UnitNumber from '../inputs/property-details/UnitNumber'
import VillageName from '../inputs/property-details/VillageName'

export default {
  props: ['value'],
  inject: ['$validator'],
  components: {
    UnitNumber,
    VillageName
  },
  data() {
    return {
      data: {
        villageName: this.value.villageName,
        unitNumber: this.value.unitNumber
      }
    }
  },
  methods: {
    update: function() {
      this.$emit('input', this.data)
    }
  }
}
</script>

<style scoped>
.mqu-title {
  font-family: 'National-Extrabold';
}

.mqu-subtitle {
  font-family: 'National-Light';
}
</style>



// WEBPACK FOOTER //
// src/components/modules/stages/PropertyDetails.vue